import React from 'react';
import { Radio } from 'react-bootstrap';
import { Field } from 'redux-form';
import styled from 'styled-components';

const BooleanFieldsGrid = styled.div`
  display: flex;
`;
const ButtonWrapper = styled.div`
  flex: 1;
  &:not(:first-of-type) {
    margin-left: 15px;
  }

  margin-left: 0;
`;
const RadioInput = styled(Radio)`
  margin-top: 0 !important;

  > label {
    width: 100% !important;
    height: 60px !important;
    position: absolute !important;
    opacity: 0;
    padding: 0 !important;
  }
`;

const RadioButton = styled.div`
  height: 60px;
  width: 100%;
  color: white;
  opacity: 1;
  font-size: 16px;
  -webkit-transition: 0.3s ease;
  transition: 0.3s ease;
  min-height: 60px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  justify-content: space-around;
  border-radius: 100px;
  font-weight: bold;
  padding: 1em 2em;
  ${(props) =>
    props.isActive
      ? `
        background: #312276;
        -webkit-box-shadow: 0 4px 6px rgba(0, 0, 0, 0.7);
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.7);
    `
      : `
        background: #21174F;
    `}
`;

const Button = ({ input, componentValue, label }) => {
  const checked = input.value.toString() === componentValue.toString();
  return (
    <>
      <RadioInput {...input} value={componentValue} checked={checked} />
      <RadioButton isActive={checked}>{label}</RadioButton>
    </>
  );
};

export const ButtonGroup = ({ input, options }) => {
  return (
    <BooleanFieldsGrid>
      {options.map((option) => {
        return (
          <ButtonWrapper key={option.label}>
            <Field
              name={input.name}
              label={option.label}
              value={input.value}
              componentValue={option.value}
              component={Button}
            />
          </ButtonWrapper>
        );
      })}
    </BooleanFieldsGrid>
  );
};
